var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlackTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "{className}",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2693 6.43909C15.5101 6.68645 15.5047 7.08214 15.2573 7.32289L8.83564 13.5729C8.593 13.809 8.20645 13.809 7.96381 13.5729L4.56409 10.2641C4.31672 10.0233 4.31136 9.62763 4.55211 9.38026C4.79286 9.1329 5.18855 9.12754 5.43591 9.36829L8.39972 12.2529L14.3855 6.42711C14.6329 6.18636 15.0286 6.19172 15.2693 6.43909Z",
    fill: "#00013A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackTick);
export default __webpack_public_path__ + "static/media/black-tick.4cfc670b68da9d3e66c27e4c5a60c3d8.svg";
export { ForwardRef as ReactComponent };